<div class="row text-center" [ngClass]="{'ma-validate-phone': !isAcmic}">
  <div class="col">
    <h1 class="title-copy">
      {{ "VALIDATE_WITH_PHONE" | translate }}
    </h1>
    <p class="validate-phone">
      {{ "THE_FOLLOWING_PHONE_NUMBER_IS_ASSOCIATED_WITH_POLICY" | translate }}
    </p>
    <div class="email-title mb-3 lh24">
      <b>{{ phone }}</b>
    </div>
    <mapfre-button
      additionalClasses="basic primary large-btn margin-bottom mb24"
      (click)="sendOtp()"
    >
      {{ "SEND_CODE" | translate }}
    </mapfre-button>
    <p class="fs-lh">{{ "TEXT_MESSAGE_CHARGES" | translate }}</p>
    <ng-container *ngIf="isAcmic; else MAstate">
        <div class="margin-bottom mb24 ">
          <div class="assistance acmic margin-top mt16">
            <p class="no-margin-bottom">
              {{ "UPDATE_YOUR_PHONE_NUMBER" | translate }}
            </p>
            <p>
              {{ "CONTATC_US_AT" | translate }}
            </p>
              <a class="underline mapfre link blue-link" href="tel:18442954500">
                {{ "TELL_NUMBER" | translate}}
              </a>
          </div>
      </div>  
    </ng-container>
      <ng-template #MAstate>
        <div>
          <div class="not-a-mobile">{{ "NOT_A_MOBILE" | translate }}</div>
          <div *ngIf="userData.phone && !userData.email" class="s-code mt-2">
            <mapfre-button
              (click)="sendToAccountVerification()"
              additionalClasses="mapfre link ghost secondary warn-ghost font-size-16 small no-margin btn small-btn"
            >
              {{ "USE_EMAIL" | translate }}
            </mapfre-button>
          </div>
          <div *ngIf="userData.phone && userData.email" class="s-code">
            <mapfre-button
              (click)="sendToAccountVerification()"
              additionalClasses="mapfre link ghost secondary warn-ghost font-size-16 small no-margin btn small-btn"
            >
              {{ "USE_DIFFERENT_EMAIL" | translate }}
            </mapfre-button>
          </div>
        </div>
      </ng-template>
    <div class="row mt-2 text-center checkingrowbtm" *ngIf="email">
      <div class="col">
        <mapfre-button
          (click)="backToEmailValidateScreen()"
          additionalClasses="link-button small-btn red-link no-margin button-border-red"
          [backIcon]="'assets/img/icons/back-arrow-red.png'"
          [iconClasses]="'align-middle'"
          [showIconsCustom]="true"
        >
          {{ "BACK" | translate }}
        </mapfre-button>
      </div>
    </div>
  </div>
</div>
